import { getHeaders, makeRequest } from '@orientaction/utils';
import config from './config';

const qs = require('qs');

const url = config.api_url;

export const getNeedsTestResults = async (token: string) => {
  const searchParams = qs.stringify(
    {
      populate: ['users_permissions_user'],
      sort: ['createdAt:desc'],
    },
    {
      encodeValuesOnly: true,
    }
  );
  return makeRequest(`${url}/api/needs-test-results?${searchParams}`, 'GET', {}, getHeaders(token));
};

export const getMyResultNeed = async (token: string, id: number) => {
  return makeRequest(`${url}/api/get-result-need-test/${id}`, 'GET', {}, getHeaders(token));
};

export const getNeedsTestResultDetails = async (token: string, data: any) => {
  return makeRequest(`${url}/api/get-needs-test-result-details`, 'POST', data, getHeaders(token));
};
